import React, { useState } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import BasicModal from "../../core/BaseComponents/Modal";
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from "@mui/material";
import Slider from "react-slick";

const ScreenSaverConfigList = (props) => {
    const [showPreviewPopUp, setShowPreviewPopUp] = useState([]);
    const [showVideoPreviewPopUp, setvideoShowPreviewPopUp] = useState(false);
    const [initialSlide, setInitialSlide] = useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      };

    const renderConfigImages = (row) => (
        <div className="delete-config-images">
            {row?.screenSaverImages?.slice(0, 4)?.map((url, index) => (
                <div key={url}>
                    <img src={url} alt={url} onClick={() => BannerPreviewHandler(row?.screenSaverImages, index)} />
                </div>
            ))}
            {row?.screenSaverImages?.length > 4 && <span>...<span onClick={() => BannerPreviewHandler(row?.screenSaverImages, 0)} className="ms-2 cdsn-count">+{row?.screenSaverImages?.length - 4}</span></span>}
        </div>
    )

    const BannerPreviewHandler = (screenSaverImages, index) => {
        setShowPreviewPopUp(screenSaverImages);
        setInitialSlide(index);
    }

    const columns = [
        { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "configName", headerName: "Config Name", flex: 1 },
        { field: "screensaverDetails", headerName: "Screensaver Details", flex: 1, row: true, renderCell: renderConfigImages, flex: 0.5, disableSortIcon: true, },
    ];

    return (
        <div className="hotel-list">
            <p><b> Screen Saver Details</b></p>
            <TableWrapper
                data={[props?.fetchCDSNSsConfigList]}
                columns={columns}
                noPagination={true}
            />
            {showPreviewPopUp.length > 0 && <BasicModal
                popupOpen={showPreviewPopUp.length > 0}
                popupCloseHandler={() => { setShowPreviewPopUp('') }}
                isCross={true}
                heading={'Screensaver Images Preview'}
                popupSize='col-8 px-5'
                bodyMessage={
                    <div className="preview-banner-img">
                        {
                            showPreviewPopUp?.length > 1 ? <>
                                <Slider {...settings} className="preview-slider-image mx-4">
                                    {showPreviewPopUp?.map((bannerImagesList) =>
                                            <img src={bannerImagesList} alt={bannerImagesList} />
                                    )}
                                </Slider>
                            </> : <div className="preview-banner-img screen-single-image">
                                <>
                                    <img src={showPreviewPopUp[0]} alt={showPreviewPopUp[0]} width={100} />
                                </>
                            </div>
                        }
                    </div>
                }
            />}
        </div>
    )
}

export default ScreenSaverConfigList;